import React from 'react';
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from '@stripe/react-stripe-js';

const CreditCardForm = ({ 
  cardName, 
  onCardNameChange, 
  getCurrencySymbol, 
  price,
  stripeEnabled,
  isLifetime = false
}) => {
  const buttonText = isLifetime 
    ? `Complete payment for ${getCurrencySymbol()}${price}`
    : `Complete subscription for ${getCurrencySymbol()}${price}`;

  return (
    <div>
      <div className="flex flex-col sm:flex-row gap-2 mt-4">
        <div className="w-full md:w-5/7 flex gap-3 md:flex-row flex-col">
          <div className="flex-1">
            <label className="font-inter font-light text-[10px] text-dark-500 mb-1 block">
              Name on Card
            </label>
            <input
              type="text"
              placeholder="Name on Card"
              value={cardName}
              onChange={onCardNameChange}
              required
              className="rounded-sm border-[0.78px] border-dark-500/20 outline-none h-[34px] px-[10.9px] bg-primary-950 font-inter font-normal text-[12.45px] leading-[18.68px] w-full"
            />
          </div>
          <div className="flex-1">
            <label className="font-inter font-light text-[10px] text-dark-500 mb-1 block">
              Card Number
            </label>
            <div className="rounded-sm border-[0.78px] border-dark-500/20 bg-primary-950 px-[10.9px] h-[34px]">
              <CardNumberElement
                options={{
                  style: {
                    base: {
                      lineHeight: '34px',
                      fontSize: '12.45px',
                      background: 'transparent',
                      fontWeight: '400',
                    },
                  },
                }}
              />
            </div>
          </div>
        </div>
        <div className="flex-1">
          <label className="font-inter font-light text-[10px] text-dark-500 mb-1 block">
            Expiry
          </label>
          <div className="rounded-sm border-[0.78px] border-dark-500/20 bg-primary-950 px-[10.9px] h-[34px] min-w-[100px]">
            <CardExpiryElement
              options={{
                style: {
                  base: {
                    lineHeight: '34px',
                    fontSize: '12.45px',
                    background: 'transparent',
                    fontWeight: '400',
                    minWidth: '100px',
                  },
                },
              }}
            />
          </div>
        </div>
        <div className="flex-1">
          <label className="font-inter font-light text-[10px] text-dark-500 mb-1 block">
            CVC
          </label>
          <div className="rounded-sm border-[0.78px] border-dark-500/20 bg-primary-950 px-[10.9px] h-[34px] min-w-[100px]">
            <CardCvcElement
              options={{
                style: {
                  base: {
                    lineHeight: '34px',
                    fontSize: '12.45px',
                    background: 'transparent',
                    fontWeight: '400',
                  },
                },
              }}
            />
          </div>
        </div>
      </div>
      <button
        type="submit"
        disabled={!stripeEnabled}
        className="rounded-sm sm:text-[19px] text-sm p-3 text-primary100 bg-secondary100 text-center mt-4 cursor-pointer w-full"
      >
        Pay $0 Today
      </button>
    </div>
  );
};

export default CreditCardForm;
